<div class="message">
  @if (melding) {
    <ion-icon [icon]="icon" class="message-icon error-icon" />
    <span class="message-text">
      @if (melding.examTypeDescription) {
        {{ melding.examTypeDescription }} -
      }
      {{ melding.message }}
    </span>
  }
</div>
